import script from "./RunGroupHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./RunGroupHeader.vue?vue&type=script&setup=true&lang=ts"

import "./RunGroupHeader.vue?vue&type=style&index=0&id=19ac9b76&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19ac9b76"]])

export default __exports__